export default __webpack_public_path__ + "static/media/newrelic.c8e58cb245c21bbde28e13cdb4b59a81.svg";